import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'protection-plans',
  templateUrl: './protection-plans.component.html',
  styleUrls: ['./protection-plans.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProtectionPlansComponent implements OnInit {
  @Input() premiumDisruptionAssistance: boolean;
  @Input() cancelForAnyReason: boolean;
  @Input() ancillaryUpsell: boolean;

  @Output() editClick = new EventEmitter();

  protections: { img: string; label: string }[] = [];

  ngOnInit() {
    if (this.premiumDisruptionAssistance) {
      this.protections.push({ img: 'local_police_blue', label: 'Premium disruption assistance' });
    }

    if (this.cancelForAnyReason) {
      this.protections.push({ img: 'diamond_blue', label: 'Cancel for any reason' });
    }
  }
}
